import clsx from 'clsx';
import * as React from 'react';

export type BackdropProps = React.ComponentPropsWithoutRef<'div'> & {
    /**
     * Whether the backdrop is entering.
     */
    isEntering?: boolean;

    /**
     * Whether the backdrop is exiting.
     */
    isExiting?: boolean;
};

/**
 * A backdrop that covers the entire screen.
 */
export const Backdrop = React.forwardRef(function Backdrop(
    props: BackdropProps,
    ref: React.ForwardedRef<HTMLDivElement>
) {
    const { isEntering, isExiting, className, ...rest } = props;
    return (
        <div
            ref={ref}
            {...rest}
            className={clsx(
                'fixed inset-0 bg-[lch(0_0_0_/_0.275)] fill-mode-forwards',
                isExiting && 'fade-out animate-out ease-in',
                isEntering && 'fade-in animate-in ease-out',
                className
            )}
        />
    );
});
